module.exports = __webpack_public_path__ + "img/Tier 2 Alternatives_02_LRT_Driveway Impacts.2da1f65c.jpg";